import Config from "services/config/config";
import callWebService, { callTypes } from "services/utils/networks/network";
import { SITE_ENGINEER_DETAILS } from "./type";

export const getSiteEngineerDetails = (enggID) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    "",
    `${Config.installation.siteEngineerDetails}?site_engineer_id=${enggID}`
  );
  if (res) {
    const { data } = res;
    dispatch({
      type: SITE_ENGINEER_DETAILS,
      payload: data.response.data,
    });
    return data.response.data;
  }
};

